module.exports = window["core-js/modules/es.object.get-own-property-descriptors.js"];